import { ObservationStatus as GraphqlStatus } from "@acto/gql/graphql";

export default class ObservationStatus {
  static OPEN = new ObservationStatus("open");
  static DELETED = new ObservationStatus("deleted");
  static COMPLETED = new ObservationStatus("completed");
  #value: string;

  private constructor(value: string) {
    this.#value = value;
  }

  static fromGraphql(status: GraphqlStatus): ObservationStatus {
    switch (status) {
      case GraphqlStatus.Open:
        return ObservationStatus.OPEN;
      case GraphqlStatus.Deleted:
        return ObservationStatus.DELETED;
      case GraphqlStatus.Completed:
        return ObservationStatus.COMPLETED;
      default:
        throw new Error(`Unknown observation status: ${status}`);
    }
  }

  public toGraphql(): GraphqlStatus {
    switch (this.#value) {
      case "open":
        return GraphqlStatus.Open;
      case "deleted":
        return GraphqlStatus.Deleted;
      case "completed":
        return GraphqlStatus.Completed;
      default:
        throw new Error(`Unknown observation status: ${this.#value}`);
    }
  }

  public toString(): string {
    return this.#value;
  }
}
